import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import KNQuoteAttribute from 'components/KNQuoteAttribute/KNQuoteAttribute'
import { GuestUserContext } from 'context/authentication/GuestUserContext'
import {
  getFluidsVolumeMeasurement,
  getFluidsVolumeUnit,
  getFormattedUnit,
  getWeightMeasurement,
  getWeightUnit,
} from 'global/helpers/units'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import type { DangerousGoods } from './QuoteDetails.types'

export interface DangerousGoodsDetailsProp {
  dangerousGoodsDetails: DangerousGoods
}

const DangerousGoodsDetails = ({ dangerousGoodsDetails }: DangerousGoodsDetailsProp) => {
  const { t } = useTranslation()
  const [guestUserState, _guestUserDispatch] = useContext(GuestUserContext)

  return (
    <Grid container marginBottom={2}>
      <Grid size={{ xs: 12 }}>
        {dangerousGoodsDetails.unCode &&
          <Typography variant="p4" component="p" color="primary.main">{dangerousGoodsDetails.unCode}</Typography>}
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        {dangerousGoodsDetails.limitedQuantity !== null && <KNQuoteAttribute
          value={dangerousGoodsDetails.limitedQuantity ? t('general.yes') : t('general.no')}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.limitedQuantity')}
        />}
        {dangerousGoodsDetails.exceptedQuantity !== null && <KNQuoteAttribute
          value={dangerousGoodsDetails.exceptedQuantity ? t('general.yes') : t('general.no')}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.exceptedQuantity')}
        />}
        {dangerousGoodsDetails.name && <KNQuoteAttribute
          value={dangerousGoodsDetails.name}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.name')}
        />}
        {dangerousGoodsDetails.technicalName && <KNQuoteAttribute
          value={dangerousGoodsDetails.technicalName}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.technicalName')}
        />}
        {dangerousGoodsDetails.englishTechnicalName && <KNQuoteAttribute
          value={dangerousGoodsDetails.englishTechnicalName}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.englishTechnicalName')}
        />}
        {dangerousGoodsDetails.weight && <KNQuoteAttribute
          value={getWeightMeasurement(dangerousGoodsDetails.weight, guestUserState.measurementsSystem)}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.weight')}
          suffix={getFormattedUnit(getWeightUnit(guestUserState.measurementsSystem))}
        />}
        {dangerousGoodsDetails.volume && <KNQuoteAttribute
          value={getFluidsVolumeMeasurement(dangerousGoodsDetails.volume, guestUserState.measurementsSystem)}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.volume')}
          suffix={getFormattedUnit(getFluidsVolumeUnit(guestUserState.measurementsSystem))}
        />}
        {dangerousGoodsDetails.classification && <KNQuoteAttribute
          value={dangerousGoodsDetails.classification}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.class')}
        />}
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        {dangerousGoodsDetails.netExplosiveMass !== undefined && dangerousGoodsDetails.netExplosiveMass !== null && <KNQuoteAttribute
          value={dangerousGoodsDetails.netExplosiveMass.toString()}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.netExplosiveMass')}
        />}

        {dangerousGoodsDetails.highConsequence !== null && <KNQuoteAttribute
          value={dangerousGoodsDetails.highConsequence ? t('general.yes') : t('general.no')}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.highConsequence')}
        />}

        {dangerousGoodsDetails.environmentalHazard !== null && <KNQuoteAttribute
          value={dangerousGoodsDetails.environmentalHazard ? t('general.yes') : t('general.no')}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.environmentalHazard')}
        />}

        {dangerousGoodsDetails.packingGroup && <KNQuoteAttribute
          value={dangerousGoodsDetails.packingGroup}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.packingGroup')}
        />}

        {dangerousGoodsDetails.tunnelCode && <KNQuoteAttribute
          value={dangerousGoodsDetails.tunnelCode}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.tunnelCode')}
        />}

        {dangerousGoodsDetails.adrExemptions && <KNQuoteAttribute
          value={dangerousGoodsDetails.adrExemptions}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.adrExemptions')}
        />}

        {dangerousGoodsDetails.adrPackage?.type && <KNQuoteAttribute
          value={dangerousGoodsDetails.adrPackage.type}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.adrPackageType')}
        />}

        {dangerousGoodsDetails.adrPackage?.number && <KNQuoteAttribute
          value={dangerousGoodsDetails.adrPackage.number}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.adrPackageNumber')}
        />}

        {dangerousGoodsDetails.notOtherwiseSpecified && <KNQuoteAttribute
          value={dangerousGoodsDetails.notOtherwiseSpecified ? t('general.yes') : t('general.no')}
          prefix={t('screens.cs.carrier_quotes.quote_accordion.notOtherwiseSpecified')}
        />}
      </Grid>
    </Grid>
  )
}

export default DangerousGoodsDetails

